import { yupResolver } from '@hookform/resolvers/yup';
import { useFieldArray, useForm } from 'react-hook-form';
import { addTagsFormSchema } from './add-tags-form.schema';
import { UseCustomersTagsReturnType } from 'hooks/customer-tags.hooks';
import { useEffect } from 'react';

export const useAddCustomerTagsForm = (
  customersTags: UseCustomersTagsReturnType,
) => {
  const form = useForm({
    resolver: yupResolver(addTagsFormSchema),
    defaultValues: customersTags.customersTags
      ? { tags: customersTags.customersTags }
      : addTagsFormSchema.cast({}),
  });

  const customerTagFields = useFieldArray({
    name: 'tags',
    control: form.control,
  });

  useEffect(() => {
    form.reset({
      tags: customersTags.customersTags ? customersTags.customersTags : [],
    });
  }, [customersTags.customersTags, form]);

  return { form, customerTagFields };
};
